import { render } from "./CustomRange.vue?vue&type=template&id=63f8ab66&scoped=true&ts=true"
import script from "./CustomRange.vue?vue&type=script&lang=ts"
export * from "./CustomRange.vue?vue&type=script&lang=ts"

import "./CustomRange.vue?vue&type=style&index=0&id=63f8ab66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f8ab66"]])

export default __exports__